// @flow

import composeRecommendationsDataTable from './datatable'
export default composeRecommendationsDataTable
